import { coreFolowDeleteRoute } from '@/modules/library/domain/routes/libraryRoutes';
import { requestQuery } from '@/services/request';

export const deleteProgramFollow = async (followId: string) =>
  requestQuery<void>({
    method: 'DELETE',
    url: coreFolowDeleteRoute(followId),
  });
